module.exports = __webpack_public_path__ + "img/03cd8a0.png";